import mapboxgl from "mapbox-gl";
import { useNetworkBoundariesLayer } from "../hooks/useNetworkBoundariesLayer";
import { CoamAreaFeature } from "../../geospatial/api/coamArea";

interface NetworkBoundariesLayerProps {
  map: mapboxgl.Map | null;
  features: CoamAreaFeature[];
}

export const NetworkBoundariesLayer = ({
  map,
  features,
}: NetworkBoundariesLayerProps) => {
  useNetworkBoundariesLayer({ map, features });
  return null;
};

